import { StyleSpecification } from 'maplibre-gl';
import { Layer } from '@deck.gl/core/typed';
import { MapLayerConfigFragmentFragment } from '@kinetic-ui/data-layer';

export interface useDeckGlTileLayersResult {
  style: StyleSpecification | undefined;
  layers: Layer[];
  mapLayers: React.ReactNode;
  selectedBaseLayerConfig?: MapLayerConfigFragmentFragment;
}

export enum GoogleMapType {
  ROADMAP = 'roadmap',
  SATELLITE = 'satellite',
}
